import { observable, action, computed } from 'mobx'
import Api from '@api/jiaMeng'
import { isPhone } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import { message } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import { hashHistory } from 'react-router'
import { JIAMENG_CUSTOMER_DETAIL_PATH } from '@constant'

/**
 * 这个 Store 也用在 /localMerchant/insertCustomer
 */
class Store {
  @observable searchText = ''
  @observable drawerVisible = false
  @observable customer = {}
  @observable loading = false
  @observable warningText = ''
  @observable searched = false // 是否搜索过, 若重置则恢复 false

  constructor(mode) {
    this.mode = mode // 类型，drawer或route
  }

  @action
  onChange = e => {
    this.searchText = e.target.value
  }

  @action
  reset = () => {
    this.searchText = ''
    this.searched = false
    this.customer = {}
    this.warningText = ''
  }

  @action
  toggleDrawer = () => {
    this.drawerVisible = !this.drawerVisible
  }

  searchCustomerByPhone = async () => {
    if (!isPhone(this.searchText)) {
      return message.warn('请输入正确的手机号码')
    }

    this.loading = true
    const { success, data } = await Api.searchCustomerByPhone({
      phone: this.searchText
    })
    this.loading = false

    if (!this.searched) {
      this.searched = true
    }

    if (success) {
      this.customer = data
      const warningTxt = '未查询到预约或婚礼纪账号，请手动录入'
      const hasCustomer = !isEmpty(data)

      if (!hasCustomer) {
        if (this.mode === 'route') {
          message.warn(warningTxt)
        } else {
          this.warningText = warningTxt
        }
      } else {
        this.warningText = ''

        if (this.mode === 'route') {
          setTimeout(() => {
            this.check()
          }, 100)
        }
      }
    }
  }

  @computed
  get hasCustomer() {
    return !isEmpty(this.customer)
  }

  @computed
  get customerDetail() {
    const { id, user } = this.customer

    if (id) {
      return {
        ...this.customer,
        avatar: dGet(this.customer, 'user.avatar')
      }
    }

    return {
      ...user,
      user_name: dGet(this.customer, 'user.name')
    }
  }

  /**
   * 创建/创建并标记到店参数
   * 如果 customer 节点有 id，则使用该 id
   * 如果没有，则使用 customer 节点下 user 节点的 id
   */
  getCreateParams = () => {
    if (this.customer.id) {
      return {
        id: this.customer.id
      }
    } else {
      return {
        user_id: dGet(this.customer, 'user.id')
      }
    }
  }

  check = async () => {
    const { success, data } = await Api.createCustomer(this.getCreateParams())

    if (success && !isEmpty(data)) {
      this.gotoCustomerDetail(data.id)
    }
  }

  markThenCheck = async () => {
    const { success, data } = await Api.createCustomerThenMark(
      this.getCreateParams()
    )

    if (success) {
      this.gotoCustomerDetail(data.id)
    }
  }

  gotoCustomerDetail = customer_user_id => {
    hashHistory.push(`${JIAMENG_CUSTOMER_DETAIL_PATH}/${customer_user_id}`)
  }
}

export default Store
